var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxTaped = function SvgBoxTaped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.335 6.125 4.8 11.2h8l1.6-6.4H9.485c-.91 0-1.74.515-2.15 1.325M19.2 11.2h8l-2.535-5.075a2.41 2.41 0 0 0-2.15-1.325H17.6zm-6.4 1.6h-8V24c0 1.765 1.435 3.2 3.2 3.2h16c1.765 0 3.2-1.435 3.2-3.2V12.8h-8V16c0 .885-.715 1.6-1.6 1.6h-3.2c-.885 0-1.6-.715-1.6-1.6z"
  })));
};
export default SvgBoxTaped;